import React from 'react';
import { FiEdit } from 'react-icons/fi';

import { ISelectionLabel } from '../../@interfaces';
import { useTheme } from 'styled-components';
import Subtitle from '../subtitle';
import Text from '../text';

const SelectionLabel: React.FC<ISelectionLabel> = ({ label, value, onClick }) => {
  const theme = useTheme();

  return (
    <div className="flex flex-col w-full gap-1">
      {label && (
        <Subtitle className="!text-[.85rem] !font-semibold !mb-1">
          {label}
        </Subtitle>
      )}

      <button
        type="button"
        onClick={onClick}
        className="
          w-full
          flex
          items-center
          justify-between
          bg-[#ECF1F6]
          text-[#001120]
          text-[.9rem]
          px-[10px]
          py-[8px]
          rounded-[4px]
          !border
          border-solid
          border-gray-300
          font-light
          transition-colors
          hover:bg-[#E6ECF3]
          cursor-pointer"
      >
        <Text className='!text-[.85rem]'>{value}</Text>
        <FiEdit size={16} className="text-gray-500 shrink-0" />
      </button>
    </div>
  )
}

export default SelectionLabel;